<script setup>
defineEmits(['click']);
</script>

<template>
    <button
        class="flex items-center justify-center w-[44px] h-[44px] shrink-0 rounded-full border border-(--magenta) bg-transparent text-(--magenta) transition-colors duration-200 hover:bg-(--magenta) hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--magenta)"
        aria-label="Search"
        @click="$emit('click')">
        <svg aria-hidden="true" class="w-[14px] h-[14px]" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7.5" cy="7.5" r="6.5" stroke="currentColor" stroke-width="1.5" />
            <path d="M12.5 12.5L17 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
    </button>
</template>
